"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumberBadgeColors = void 0;
var NumberBadgeColors;
(function (NumberBadgeColors) {
    NumberBadgeColors["black"] = "color-ui-black";
    NumberBadgeColors["blue"] = "color-cobalt";
    NumberBadgeColors["darkgray"] = "color-ui-dark-gray";
})(NumberBadgeColors = exports.NumberBadgeColors || (exports.NumberBadgeColors = {}));



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/NumberBadge/NumberBadgeProps.js
// module id = 1796
// module chunks = 8